<template>
    <v-container fluid class="pa-3" v-if="sessionActive">

        <material-header
            title="Sub panels"
            info="Divide your panel into multiple independent communities"
            icon="mdi-sitemap"
            :loading="loading">

            <template slot="buttons">

                <v-tooltip top color="primary">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon text @click="reloadClicked">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>

                    <span>Reload view</span>
                </v-tooltip>

                <v-tooltip top color="primary" v-if="hasPermission('create sub panels')">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" fab small class="elevation-0" color="primary" @click="addSubpanelClicked">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Create new sub panel</span>
                </v-tooltip>
            </template>

        </material-header>

        <v-alert v-if="!hasPermission(minPermission)"
                 class="body-2"
                 type="error"
        >
            Your user account doesn't have sufficient permissions for this feature
        </v-alert>

        <div class="d-flex flex-wrap pa-0 pt-0" v-if="sessionActive">

            <div class="sub-panel-box pt-2 pr-2 flex-grow-1"
                 v-for="(subPanel,index) in subPanels" :key="subPanel.id"
                 v-if="hasPermission(minPermission)">

                <sub-panel-box
                    :data="subPanel"
                    :uploading="uploading"
                    @logo="logoUploaded"
                ></sub-panel-box>

            </div>

        </div>

    </v-container>
</template>

<script>

import Json from 'vue-json-pretty';
import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
import MaterialHeader from '../../../components/UI/MaterialHeader';
import SubPanelBox from './SubPanelBox';
import {mapActions, mapState} from 'vuex';

export default {

    mixins: [activeSessionChecker],

    components: {
        Json,
        MaterialHeader,
        SubPanelBox
    },

    data() {
        return {
            minPermission: 'view sub panels',
            editButtonVisible: false
        }
    },
    computed: {
        ...mapState('SubPanels', [
            'subPanels',
            'uploading',
            'loading'
        ])
    },

    methods: {

        ...mapActions('SubPanels', [
            'loadSubPanels',
            'updateLogo'
        ]),

        reloadClicked() {
            this.loadSubPanels(true)
                .then(() => {
                    Bus.$emit('flash-message', {message: 'Sub panels reloaded!'});
                })
                .catch(() => {
                    Bus.$emit('flash-message', {type: 'error', message: 'Oops! Sub panels failed to reload!'});
                });
        },

        addSubpanelClicked() {
            this.$router.push({name: 'subpanel-create'});
        },

        logoUploaded(formData) {
            this.updateLogo(formData)
                .then(() => {
                    Bus.$emit('flash-message', {message: 'Sub panel logo has been updated!'});
                })
                .catch((error) => {
                    Bus.$emit('flash-message', {type: 'error', message: 'Oops! Sub panel logo failed to update!'});
                });
        },
    },
}

</script>

<style scoped>

.sub-panel-box {
    min-width: 590px;
    max-width: 590px;
}

</style >

